import axios from "axios";
import Config from "../../config";

import { callNotification, sessionExpired, getUTCOffset } from "../constants";
import { handleApiError, handleAxiosError } from "../utils/errorHandler";

export const getfeedbackResponse = (feedbackObj) => {
  return (dispatch) => {
    let url = `${Config.config1.api_link}/feedback`;

    // Custom error handlers for specific error codes
    const customErrorHandlers = {
      9: (errorCodeValue, errorMessage, response, dispatch) => {
        // Session expired - use existing session management
        sessionExpired(true);
        !feedbackObj?.report_download &&
          callNotification(errorMessage, "error");
      },
      default: (errorCodeValue, errorMessage, response, dispatch) => {
        // Default error handling for other error codes including 21
        !feedbackObj?.report_download &&
          callNotification("Request failed. Please try again!", "error");
      },
    };

    axios
      .post(url, { ...feedbackObj, utcoffset: getUTCOffset() })
      .then((response) => {
        if (response.data.status === "successful") {
          dispatch({
            type: "SET_FEEDBACK_RESPONSE",
            payload: response,
          });
          !feedbackObj?.report_download &&
            callNotification("Your request has been submitted!", "success");
        } else if (response.data.status === "error") {
          handleApiError(response, dispatch, { customErrorHandlers });
        }
      })
      .catch((error) => {
        handleAxiosError(error, dispatch, { customErrorHandlers });
      });
  };
};

export const displayFeedback = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_FEEDBACK", payload: value });
  };
};

export const setSidebarVisibility = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SIDEBAR_VISIBILITY", payload: value });
  };
};
